var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.877,
    height: 67.158,
    viewBox: "0 0 41.877 67.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90535",
    "data-name": "Group 90535",
    transform: "translate(-197.262 -243.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.817,23.6A8.9,8.9,0,1,1,29.736,14.7a2.913,2.913,0,0,0,5.827,0,14.747,14.747,0,1,0-24.28,11.213A20.751,20.751,0,0,0,0,44.352V51.4a2.913,2.913,0,0,0,5.827,0V44.352a14.99,14.99,0,0,1,29.979,0V51.4a2.914,2.914,0,0,0,5.829,0V44.352A20.808,20.808,0,0,0,20.817,23.6Z",
    transform: "translate(197.262 256.179)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20.732.013a.182.182,0,0,1,.135,0L41.486,8.3a.18.18,0,0,1,.007.331L20.874,17.964a.182.182,0,0,1-.149,0L.105,8.636A.18.18,0,0,1,.112,8.3Z",
    transform: "translate(197.541 243.328)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconOnly);
export default __webpack_public_path__ + "static/media/logo-icon-only.dc44df04a1a4ed4ebedef4041eb3a5b3.svg";
export { ForwardRef as ReactComponent };